import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M480-362q-8 0-15-2.5t-13-8.5L268-557q-11-11-11-28t11-28 28-11 28 11l156 156 156-156q11-11 28-11t28 11 11 28-11 28L508-373q-6 6-13 8.5t-15 2.5" }, null, -1)
  ])))
}
export default { render: render }